import { render, staticRenderFns } from "./CreateAd.vue?vue&type=template&id=422c5ddc&"
import script from "./CreateAd.vue?vue&type=script&lang=js&"
export * from "./CreateAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports